
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6cfXd", function(module, exports) {
/* PublishButtonWithMoreOptions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $afneb = parcelRequire("afneb");


var $1pSma = parcelRequire("1pSma");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $bflGB = parcelRequire("bflGB");


var $gnkil = parcelRequire("gnkil");


var $cEgMD = parcelRequire("cEgMD");

/* ConfluenceRecapPublishSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $cbc8g = parcelRequire("cbc8g");





var $hSqtY = parcelRequire("hSqtY");


var $lsxnT = parcelRequire("lsxnT");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");


var $e4o8D = parcelRequire("e4o8D");

const $e1da83584e7b4e17$var$i18n = (0, $aXWIB.defineMessages)({
    header: {
        id: "confluence-recap.publish-spotlight.header",
        defaultMessage: "Ready to share?"
    },
    body: {
        id: "confluence-recap.publish-spotlight.body",
        defaultMessage: "Click publish so your team can see what you accomplished together!"
    },
    primaryAction: {
        id: "confluence-recap.publish-spotlight.primary-action",
        defaultMessage: "Got it"
    }
});
const $e1da83584e7b4e17$var$styles = {
    wikiContentOverride: "_11c81qyo"
};
const $e1da83584e7b4e17$var$ConfluenceRecapPublishSpotlightComponent = ({ children: children, onDismiss: onDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false); // PopoverContent requires client-side DOM measurements for proper positioning, e.g. getBoundingClientRect()
    // During SSR, positioning calculations fail and the spotlight appears in wrong position e.g. the top-left corner
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const handleSpotlightInteraction = (0, $42omo.useCallback)((action, actionSubject, actionSubjectIdSuffix)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: `confluenceRecapPublishSpotlight${actionSubjectIdSuffix ?? ''}`,
                source: 'confluenceRecapPublishSpotlight'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'CTA');
        setIsDismissed(true);
        onDismiss?.();
    }, [
        handleSpotlightInteraction,
        onDismiss
    ]);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'Dismiss');
        setIsDismissed(true);
        onDismiss?.();
    }, [
        handleSpotlightInteraction,
        onDismiss
    ]);
    if (isDismissed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        messageId: "confluence-recap-publish-spotlight",
        messageType: "engagement",
        dismiss: handleOnDismiss,
        placement: "bottom-end",
        offset: [
            -16,
            11
        ],
        isVisible: !isDismissed && !renderServerPlaceholder,
        onMessageDisposition: (status)=>{
            if (status === 'started') {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'ConfluenceRecapPublishSpotlight',
                        attributes: {
                            source: 'PublishButton'
                        }
                    }
                }).fire(); // Mark spotlight as seen with current timestamp
                setOnboardingState({
                    key: (0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT,
                    value: new Date().toISOString()
                });
                (0, $cbc8g.addUFOCustomData)({
                    confluenceRecapSpotlightDisplayed: true
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "confluence-recap-publish-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $e1da83584e7b4e17$var$styles.wikiContentOverride
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1da83584e7b4e17$var$i18n.header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        onClick: handleOnDismiss,
        autoFocus: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1da83584e7b4e17$var$i18n.body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1da83584e7b4e17$var$i18n.primaryAction)))))));
};
const $e1da83584e7b4e17$export$e521947a6b501c21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1da83584e7b4e17$var$ConfluenceRecapPublishSpotlightComponent, props));



var $l7iY7 = parcelRequire("l7iY7");








var $9YwaJ = parcelRequire("9YwaJ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");





var $6cfXd = parcelRequire("6cfXd");


var $32CBT = parcelRequire("32CBT");



function $144da3616d0f3af5$export$9beeee189ee5c097(saveDraft) {
    saveDraft?.();
    const preloadBackgroundImgLight = async ()=>await {};
    const preloadBackgroundImgDark = async ()=>await {};
    (0, $32CBT.PublishModal).preload();
    preloadBackgroundImgLight();
    preloadBackgroundImgDark();
}



var $lACKt = parcelRequire("lACKt");

const $fd4f820e56c6777b$var$i18n = (0, $aXWIB.defineMessages)({
    publishButtonTooltip: {
        id: "publish-modal.default-publish-button-tooltip",
        defaultMessage: "Select and confirm publish settings"
    }
});
const $fd4f820e56c6777b$export$3ad9bb29e820239e = ({ saveDraft: saveDraft, openModalWithAnalytics: openModalWithAnalytics, savingInProgress: savingInProgress, publishButtonDisabled: publishButtonDisabled })=>{
    const publishShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH,
        isEditorShortcut: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        component: (0, $6cfXd.WideTooltip),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $fd4f820e56c6777b$var$i18n.publishButtonTooltip),
        shortcut: publishShortcutStrings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: "primary",
        onMouseDown: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onMouseEnter: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onFocus: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onClick: openModalWithAnalytics('PublishModalPublishMoreActionsButton'),
        testId: "publish-button",
        isLoading: savingInProgress,
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lACKt.i18nShared).publishButton)));
};


/* UpdateSplitButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $ghftu = parcelRequire("ghftu");


var $buthI = parcelRequire("buthI");







var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $1s5hv = parcelRequire("1s5hv");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");





var $9wGTI = parcelRequire("9wGTI");

















var $7CeAz = parcelRequire("7CeAz");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $jmjWc = parcelRequire("jmjWc");


const $27dc3ccef38a846c$export$8bccf5cf3815156b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "QeS6p",
    name: "PublishHubDialogLoadable",
    loader: async ()=>(await (parcelRequire("4h0JT"))).PublishHubDialog
});



var $3jwuS = parcelRequire("3jwuS");


var $7mpOv = parcelRequire("7mpOv");


var $lu0E4 = parcelRequire("lu0E4");


var $6mKj3 = parcelRequire("6mKj3");


var $laFNM = parcelRequire("laFNM");

/* ReplaceApprovalModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $u9agA = parcelRequire("u9agA");




const $d3d6d12d1bf41d0f$var$i18n = (0, $aXWIB.defineMessages)({
    replaceApprovalButtonLabel: {
        id: "approvals.replace-approval.modal.replace-approval.button.label",
        defaultMessage: "Confirm"
    },
    approvedModalHeading: {
        id: "approvals.replace-approval.modal.heading.approved",
        defaultMessage: "Proceed with replacing approved content?"
    },
    approvedModalDescription: {
        id: "approvals.replace-approval.modal.description.approved",
        defaultMessage: "The published version of this page has been previously reviewed and approved. Proceeding with publish will replace the content and clear the approved status from the page."
    },
    pendingModalHeading: {
        id: "approvals.replace-approval.modal.heading.pending",
        defaultMessage: "Proceed and cancel pending review?"
    },
    pendingModalDescription: {
        id: "approvals.replace-approval.modal.description.pending",
        defaultMessage: "The published version of this page has a review pending. Proceeding with publish will replace the content and cancel the review in progress."
    }
});
const $d3d6d12d1bf41d0f$var$styles = {
    footerRow: "_zulputpp _1bahesu3 _19pkpxbi"
};
const $d3d6d12d1bf41d0f$var$ReplaceApprovalModalFooterOptions = ({ onConfirm: onConfirm })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: $d3d6d12d1bf41d0f$var$styles.footerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d3d6d12d1bf41d0f$var$i18n.replaceApprovalButtonLabel)));
};
const $d3d6d12d1bf41d0f$var$getModalCopy = (otherModeReviewStatus)=>{
    if (otherModeReviewStatus === 'PENDING') return {
        heading: $d3d6d12d1bf41d0f$var$i18n.pendingModalHeading,
        description: $d3d6d12d1bf41d0f$var$i18n.pendingModalDescription
    };
    return {
        heading: $d3d6d12d1bf41d0f$var$i18n.approvedModalHeading,
        description: $d3d6d12d1bf41d0f$var$i18n.approvedModalDescription
    };
};
const $d3d6d12d1bf41d0f$export$76d5a3513f06a31b = ({ otherModeReviewStatus: otherModeReviewStatus, onConfirm: onConfirm, onClose: onClose })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { heading: heading, description: description } = $d3d6d12d1bf41d0f$var$getModalCopy(otherModeReviewStatus);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3d6d12d1bf41d0f$var$ReplaceApprovalModalFooterOptions, {
        onConfirm: onConfirm
    }))));
};




var $jVFPV = parcelRequire("jVFPV");


var $c6abH = parcelRequire("c6abH");


var $8G6ap = parcelRequire("8G6ap");





var $ibgjl = parcelRequire("ibgjl");

const $39716b88f883e2dc$var$HOVER_DELAY_MS = 250;
const $39716b88f883e2dc$var$i18n = (0, $aXWIB.defineMessages)({
    updateButtonTooltip: {
        id: "publish-modal.update-button-tooltip",
        defaultMessage: "Update with current settings"
    },
    updateWithoutNotifyMenuItem: {
        id: "publish-modal.update-dropdown.update-without-notify",
        defaultMessage: "Update without notifying watchers"
    },
    adjustSettingsMenuItem: {
        id: "publish-modal.update-dropdown.adjust-settings",
        defaultMessage: "Adjust update settings"
    },
    updateButtonTooltipCompanyHub: {
        id: "publish-modal.update-button-tooltip-for-system-space",
        defaultMessage: "Update landing page"
    },
    publishButtonTooltipCompanyHub: {
        id: "publish-modal.publish-button-tooltip-for-system-space",
        defaultMessage: "Publish landing page"
    },
    publishButtonDisabledTooltipCompanyHub: {
        id: "publish-modal.publish-button-disabled-tooltip-company-hub",
        defaultMessage: "Only admins can publish at this time - your changes have been saved."
    },
    publishButtonCompanyHub: {
        id: "publish-modal.publish-button-for-system-space",
        defaultMessage: "Publish"
    }
});
const $39716b88f883e2dc$var$tooltipCustomizationComponentStyle = null;
const $39716b88f883e2dc$var$TooltipCustomizationComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(function TooltipCustomizationComponent({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        "data-testid": "tooltipcustomization",
        className: (0, $gMc0m.default)([
            "_11q71aqn _1yt41ppf _2rkofajl _11c8wadc _syaz15cr _vchhusvi _p12f1mjv _154iidpf _1ltvidpf _1i4q1hna _slp31hna"
        ])
    }, children);
});
const $39716b88f883e2dc$var$ButtonWrapper = ({ openModal: openModal, publishButtonDisabled: publishButtonDisabled, children: children })=>openModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
const $39716b88f883e2dc$export$43dfc6235c539691 = ({ publishButtonDisabled: publishButtonDisabled, shortcutIsEnabled: shortcutIsEnabled, openModal: openModal, saveDraft: saveDraft, flags: flags, savingInProgress: savingInProgress, shouldShowWorldIcon: shouldShowWorldIcon, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, onHoverPublish: onHoverPublish })=>{
    const [isPublishHubOpen, setIsPublishHubOpen] = (0, $42omo.useState)(false);
    const [isReplaceApprovalModalOpen, setIsReplaceApprovalModalOpen] = (0, $42omo.useState)(false);
    const [pendingPublishArgs, setPendingPublishArgs] = (0, $42omo.useState)(null);
    const intl = (0, $aXWIB.useIntl)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { handlePublish: handlePublish } = (0, $8G6ap.usePublishModalActions)();
    const publishShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH
    });
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { canPublish: canPublish, isCompanyHubPublished: isCompanyHubPublished } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const isCompanyHubPublishDisabled = isCompanyHub && !isCompanyHubPublished && !canPublish;
    publishButtonDisabled || (publishButtonDisabled = isCompanyHubPublishDisabled);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent } = (0, $42omo.useContext)((0, $ibgjl.PublishModalContext));
    const { approvalRequest: approvalRequest, otherModeReviewStatus: otherModeReviewStatus } = (0, $laFNM.useApprovals)();
    const shouldShowReplaceApprovalModal = (0, $42omo.useCallback)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return false;
         // Exception: draft was explicitly approved and view mode is not pending — this is the
        // expected publish-after-approval flow, so don't warn the user.
        const isDraftApproved = approvalRequest?.review?.reviewStatus === 'APPROVED';
        const isViewModePending = otherModeReviewStatus === 'PENDING';
        if (isDraftApproved && !isViewModePending) return false;
        return otherModeReviewStatus === 'PENDING' || otherModeReviewStatus === 'APPROVED';
    }, [
        approvalRequest?.review?.reviewStatus,
        otherModeReviewStatus
    ]);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const publishWithAnalytics = (0, $42omo.useCallback)(async (source = 'shortcut', analyticsSource = 'UpdateSplitButton', shouldNotifyOverride)=>{
        const trigger = source !== 'button' ? (0, $1C3B1.EDITOR_UPDATE_SHORTCUT_KEY_PRESS) : (0, $1C3B1.EDITOR_UPDATE_BUTTON_CLICK);
        if (contentType && contentType === 'page') (0, $lXYVJ.setViewTransitionSource)(trigger);
        const { title: title } = await retrieveEditorTitleAndContent();
        const isTitleEmpty = !title; // This check is necessary bc the publish API does not throw an error for empty title, so we need to handle this case
        if (isTitleEmpty) await (0, $jVFPV.displayPublishErrorFlag)({
            isTitleEmpty: isTitleEmpty,
            validationMessage: (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK,
            flags: flags,
            formatMessage: intl.formatMessage,
            publish: ()=>publishWithAnalytics(source, 'UpdateButtonTitleGenFlag', shouldNotifyOverride),
            isAIEnabledForContent: isAIEnabledForContent,
            isLivePage: isLivePage
        });
        else if (isCompanyHub && !isCompanyHubPublished) setIsPublishHubOpen(true);
        else handlePublish({
            analyticsSource: analyticsSource,
            shouldNotifyOverride: shouldNotifyOverride
        });
    }, [
        flags,
        intl.formatMessage,
        handlePublish,
        contentType,
        isCompanyHub,
        isCompanyHubPublished,
        isAIEnabledForContent,
        retrieveEditorTitleAndContent,
        isLivePage
    ]);
    const openReplaceApprovalModal = (0, $42omo.useCallback)((source, analyticsSource, shouldNotifyOverride)=>{
        setPendingPublishArgs({
            source: source,
            analyticsSource: analyticsSource,
            shouldNotifyOverride: shouldNotifyOverride
        });
        setIsReplaceApprovalModalOpen(true);
    }, []);
    const onReplaceApprovalConfirm = (0, $42omo.useCallback)(()=>{
        setIsReplaceApprovalModalOpen(false);
        if (pendingPublishArgs) {
            publishWithAnalytics(pendingPublishArgs.source, pendingPublishArgs.analyticsSource, pendingPublishArgs.shouldNotifyOverride);
            setPendingPublishArgs(null);
        }
    }, [
        pendingPublishArgs,
        publishWithAnalytics
    ]);
    const onReplaceApprovalClose = (0, $42omo.useCallback)(()=>{
        setIsReplaceApprovalModalOpen(false);
        setPendingPublishArgs(null);
    }, []);
    const onPublishButtonClick = async ()=>{
        if (shouldShowReplaceApprovalModal() && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) openReplaceApprovalModal('button');
        else await publishWithAnalytics('button');
    };
    const onPublishWithoutNotifyClick = async ()=>{
        if (shouldShowReplaceApprovalModal() && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) openReplaceApprovalModal('button', undefined, false);
        else await publishWithAnalytics('button', undefined, false);
    };
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // cleanup timeout on unmount
        return ()=>{
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    const onMouseEnterUpdate = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            onHoverPublish?.();
        }, $39716b88f883e2dc$var$HOVER_DELAY_MS);
    }, [
        onHoverPublish
    ]);
    const onMouseLeaveUpdate = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
    }, []);
    const buttonTooltipText = ()=>{
        if (isCompanyHub) {
            if (isCompanyHubPublishDisabled) return intl.formatMessage($39716b88f883e2dc$var$i18n.publishButtonDisabledTooltipCompanyHub);
            return isCompanyHubPublished ? intl.formatMessage($39716b88f883e2dc$var$i18n.updateButtonTooltipCompanyHub) : intl.formatMessage($39716b88f883e2dc$var$i18n.publishButtonTooltipCompanyHub);
        }
        return intl.formatMessage($39716b88f883e2dc$var$i18n.updateButtonTooltip);
    };
    const buttonText = ()=>{
        if (isCompanyHub && !isCompanyHubPublished) return intl.formatMessage($39716b88f883e2dc$var$i18n.publishButtonCompanyHub);
        return intl.formatMessage((0, $lACKt.i18nShared).updateButton);
    };
    const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
            label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
            color: "var(--ds-icon-inverse, #FFFFFF)"
        });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const chevronButton = (extraProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...extraProps,
            isDisabled: publishButtonDisabled,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip),
            testId: "publish-modal-chevron-button",
            onMouseEnter: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
            onFocus: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
            onClick: (e)=>{
                extraProps.onClick(e);
                if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'PublishModalChevronButton',
                        source: 'UpdateSplitButton'
                    }
                }).fire();
            }
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "update-split-container"
    }, shortcutIsEnabled && !publishButtonDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        key: (0, $c6abH.SHORTCUT_KEYS).USB1,
        accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH,
        listener: ()=>shouldShowReplaceApprovalModal() && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? openReplaceApprovalModal('shortcut') : publishWithAnalytics()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($39716b88f883e2dc$var$ButtonWrapper, {
        openModal: openModal,
        publishButtonDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        component: $39716b88f883e2dc$var$TooltipCustomizationComponent,
        content: buttonTooltipText(),
        shortcut: publishShortcutStrings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lu0E4.PreloadButtonWrapper), {
        isPublish: false,
        contentId: contentId ?? '',
        spaceKey: spaceKey ?? '',
        contentType: contentType ?? '',
        isUnpublishedDraft: isUnpublishedDraft ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onMouseEnter: onMouseEnterUpdate,
        onMouseLeave: onMouseLeaveUpdate,
        onClick: onPublishButtonClick,
        isDisabled: publishButtonDisabled,
        testId: "publish-modal-update-button",
        iconBefore: shouldShowWorldIcon ? WorldIcon : undefined,
        isLoading: savingInProgress,
        interactionName: "publish-page-update"
    }, buttonText()))), openModal && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>chevronButton({
                ref: triggerRef,
                ...triggerProps
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: onPublishWithoutNotifyClick
    }, intl.formatMessage($39716b88f883e2dc$var$i18n.updateWithoutNotifyMenuItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: openModal,
        testId: "update-dropdown-item-open-publish-modal"
    }, intl.formatMessage($39716b88f883e2dc$var$i18n.adjustSettingsMenuItem)))) : chevronButton({
        onClick: openModal
    }))), isPublishHubOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27dc3ccef38a846c$export$8bccf5cf3815156b), {
        onClose: ()=>setIsPublishHubOpen(false),
        onPublish: handlePublish,
        savingInProgress: savingInProgress
    }), isReplaceApprovalModalOpen && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3d6d12d1bf41d0f$export$76d5a3513f06a31b), {
        otherModeReviewStatus: otherModeReviewStatus,
        onConfirm: onReplaceApprovalConfirm,
        onClose: onReplaceApprovalClose
    }));
};












var $4KS7f = parcelRequire("4KS7f");


var $kevJM = parcelRequire("kevJM");














const $e6b2854aa19ff08b$var$i18n = (0, $aXWIB.defineMessages)({
    schedulePublishButtonTooltip: {
        id: "publish-modal.publish-modal-schedule-publish-button-tooltip",
        defaultMessage: "Adjust publish schedule and more"
    },
    scheduleUpdateButtonTooltip: {
        id: "publish-modal.publish-modal-schedule-update-button-tooltip",
        defaultMessage: "Adjust update schedule and more"
    },
    scheduledIcon: {
        id: "publish-modal.schedule-publish-icon",
        defaultMessage: "Publish is scheduled for a future time"
    },
    scheduledPublishButton: {
        id: "publish-modal.scheduled-publish-button",
        defaultMessage: "Scheduled"
    },
    schedulePublicContentLabel: {
        id: "publish-modal.public-schedule-publish-icon",
        defaultMessage: "Public content is scheduled to publish at a future time"
    }
});
const $e6b2854aa19ff08b$export$777b011347c7cf0d = ({ saveDraft: saveDraft, openModalWithAnalytics: openModalWithAnalytics, savingInProgress: savingInProgress, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon, publishButtonDisabled: publishButtonDisabled })=>{
    const intl = (0, $aXWIB.useIntl)();
    const publishShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH
    });
    const tooltipText = isUnpublishedDraft ? intl.formatMessage($e6b2854aa19ff08b$var$i18n.schedulePublishButtonTooltip) : intl.formatMessage($e6b2854aa19ff08b$var$i18n.scheduleUpdateButtonTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        component: (0, $6cfXd.WideTooltip),
        content: tooltipText,
        shortcut: publishShortcutStrings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "primary",
        onMouseDown: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onMouseOver: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onFocus: ()=>(0, $144da3616d0f3af5$export$9beeee189ee5c097)(saveDraft),
        onClick: openModalWithAnalytics('ScheduledButton'),
        // This test ID is used in tests and in experience tracking.  Be sure to update all occurences before changing it.
        testId: "scheduled-button",
        iconBefore: shouldShowWorldIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
            spacing: "spacious",
            label: intl.formatMessage($e6b2854aa19ff08b$var$i18n.schedulePublicContentLabel)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: intl.formatMessage($e6b2854aa19ff08b$var$i18n.scheduledIcon)
        }),
        isLoading: savingInProgress,
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e6b2854aa19ff08b$var$i18n.scheduledPublishButton)));
};









var $4f2ij = parcelRequire("4f2ij");





var $1N2OF = parcelRequire("1N2OF");

const $b9d16c6aaabb2602$var$wideTooltipStyle = null;
const $b9d16c6aaabb2602$export$aef42978394055f2 = /*#__PURE__*/ (0, $42omo.forwardRef)(function WideTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _1yt41ppf _syaz15cr _p12f1edt"
        ])
    }, children);
});
const $b9d16c6aaabb2602$var$tooltipTextStyle = null;
const $b9d16c6aaabb2602$export$4df9bf2432494dd1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpv77o _1e0c1txw _4cvr1h6o"
        ])
    }, children);
const $b9d16c6aaabb2602$var$PublishButtonWithMoreOptionsUnwrapped = ({ publishButtonDisabled: publishButtonDisabled, title: title, userViewingPreview: userViewingPreview, isUnpublishedDraft: isUnpublishedDraft, flags: flags, saveDraft: saveDraft, contentType: contentType, savingInProgress: savingInProgress, shouldShowWorldIcon: shouldShowWorldIcon, shouldShowFooterButtons: shouldShowFooterButtons = true, onHoverPublish: onHoverPublish })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { currentlyScheduledPublishDate: currentlyScheduledPublishDate, setExpanded: setExpanded, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, graphqlError: graphqlError, restrictionsGraphQLError: restrictionsGraphQLError } = (0, $42omo.useContext)((0, $ibgjl.PublishModalContext));
    const { handlePreview: handlePreview } = (0, $8G6ap.usePublishModalActions)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const isRecapSpotlightEligible = (0, $l7iY7.useRecapSpotlightEligibility)(isUnpublishedDraft); /**
                                                                                      * Target a field to focus on modal open.
                                                                                      */ 
    const [initialFocusTarget, setInitialFocusTarget] = (0, $42omo.useState)(undefined); /*
                                                                                                    * We have to deactivate the keyboard shortcuts for publish/update button when the publish modal is open
                                                                                                    * so that there aren't duplicate shortcuts registered.
                                                                                                    */ 
    const [shortcutIsEnabled, setShortcutIsEnabled] = (0, $42omo.useState)(true);
    const pressTracing = (0, $1pSma.default)('publish-modal-button');
    const errorToReport = (0, $42omo.useMemo)(()=>{
        const handleError = (e)=>{
            if (e) {
                if ((0, $6fil2.containsNetworkError)(e) || (0, $1uFM6.isUnauthorizedError)(e)) {
                    (0, $7Sm4c.markErrorAsHandled)(e);
                    return undefined;
                }
                return e;
            }
        };
        if (graphqlError) return handleError(graphqlError);
        if (restrictionsGraphQLError) return handleError(restrictionsGraphQLError);
    }, [
        restrictionsGraphQLError,
        graphqlError
    ]);
    const validatePageAndOpenModal = (0, $1N2OF.usePrePublishTitleValidation)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        onBeforeValidation: (0, $42omo.useCallback)(()=>{
            saveDraft?.();
        }, [
            saveDraft
        ]),
        onValidationSuccess: (0, $42omo.useCallback)(()=>{
            pressTracing();
            setShortcutIsEnabled(false);
            setIsOpen(true);
        }, [
            pressTracing
        ]),
        analyticsSource: 'PublishButtonWithMoreOptions'
    });
    const onPublishModalComplete = (0, $42omo.useCallback)(()=>{
        /** We can only re-enabled the keyboard shortcut when the modal is finished closing,
     *  because otherwise a duplicate shortcut will exist during the modal close animation.
     */ setIsOpen(false);
        setShortcutIsEnabled(true);
    }, []);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const getPrimaryButton = ()=>{
        if (!isUnpublishedDraft && !currentlyScheduledPublishDate) {
            const openModal = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? undefined : validatePageAndOpenModal('PublishModalChevronButton');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39716b88f883e2dc$export$43dfc6235c539691), {
                openModal: openModal,
                publishButtonDisabled: publishButtonDisabled,
                shortcutIsEnabled: shortcutIsEnabled,
                saveDraft: saveDraft,
                flags: flags,
                savingInProgress: savingInProgress,
                shouldShowWorldIcon: shouldShowWorldIcon,
                contentType: contentType,
                isUnpublishedDraft: isUnpublishedDraft,
                onHoverPublish: onHoverPublish
            }), shortcutIsEnabled && !savingInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !publishButtonDisabled && openModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
                key: (0, $c6abH.SHORTCUT_KEYS).PBWMO1,
                accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH_WITH_COMMENT,
                listener: ()=>{
                    setInitialFocusTarget('version comment');
                    openModal();
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
                key: (0, $c6abH.SHORTCUT_KEYS).PBWMO2,
                accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW,
                listener: ()=>handlePreview({
                        analyticsSource: 'KeyboardShortcut',
                        isUnpublishedDraft: isUnpublishedDraft
                    })
            })));
        } else {
            const publishModalButton = isRecapSpotlightEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1da83584e7b4e17$export$e521947a6b501c21), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd4f820e56c6777b$export$3ad9bb29e820239e), {
                saveDraft: saveDraft,
                openModalWithAnalytics: validatePageAndOpenModal,
                savingInProgress: savingInProgress,
                publishButtonDisabled: publishButtonDisabled
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd4f820e56c6777b$export$3ad9bb29e820239e), {
                saveDraft: saveDraft,
                openModalWithAnalytics: validatePageAndOpenModal,
                savingInProgress: savingInProgress,
                publishButtonDisabled: publishButtonDisabled
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !!currentlyScheduledPublishDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6b2854aa19ff08b$export$777b011347c7cf0d), {
                saveDraft: saveDraft,
                openModalWithAnalytics: validatePageAndOpenModal,
                savingInProgress: savingInProgress,
                isUnpublishedDraft: isUnpublishedDraft,
                shouldShowWorldIcon: shouldShowWorldIcon,
                publishButtonDisabled: publishButtonDisabled
            }) : publishModalButton, shortcutIsEnabled && !savingInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
                key: (0, $c6abH.SHORTCUT_KEYS).PBWMO3,
                accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH,
                listener: validatePageAndOpenModal(!!currentlyScheduledPublishDate ? 'ScheduledButton' : 'PublishModalPublishMoreActionsButton')
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
                key: (0, $c6abH.SHORTCUT_KEYS).PBWMO4,
                accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PUBLISH_WITH_COMMENT,
                listener: ()=>{
                    setInitialFocusTarget('version comment');
                    setExpanded(true);
                    validatePageAndOpenModal(!!currentlyScheduledPublishDate ? 'ScheduledButton' : 'PublishModalPublishMoreActionsButton')();
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
                key: (0, $c6abH.SHORTCUT_KEYS).PBWMO5,
                accelerator: (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW,
                listener: ()=>handlePreview({
                        analyticsSource: 'KeyboardShortcut',
                        isUnpublishedDraft: isUnpublishedDraft
                    })
            })));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, getPrimaryButton(), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f2ij.PublishModalDialogs), {
        isUnpublishedDraft: isUnpublishedDraft,
        contentType: contentType,
        title: title,
        publishButtonDisabled: publishButtonDisabled,
        userViewingPreview: userViewingPreview,
        initialFocusTarget: initialFocusTarget,
        shouldShowWorldIcon: shouldShowWorldIcon,
        shouldShowFooterButtons: shouldShowFooterButtons,
        onPublishModalComplete: onPublishModalComplete,
        onHoverPublish: onHoverPublish
    }), errorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: errorToReport
    }));
};
const $b9d16c6aaabb2602$export$c41c4f98f15bcd25 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})((0, $ibgjl.withPublishModalContextProvider)($b9d16c6aaabb2602$var$PublishButtonWithMoreOptionsUnwrapped));
module.exports["WideTooltip"] = $b9d16c6aaabb2602$export$aef42978394055f2;
module.exports["TooltipText"] = $b9d16c6aaabb2602$export$4df9bf2432494dd1;
module.exports["PublishButtonWithMoreOptions"] = $b9d16c6aaabb2602$export$c41c4f98f15bcd25;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<fd177939ba23d7eea0a5c1c1fd6fa501>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("4h0JT", function(module, exports) {

let $31c952ba741758d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31c952ba741758d0$var$load("gZ0i8").then(()=>parcelRequire('441I0'));

});

parcelRegister("7mpOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("jVFPV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");


var $da71s = parcelRequire("da71s");


var $gsubZ = parcelRequire("gsubZ");


var $aXWIB = parcelRequire("aXWIB");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $8mrqR = parcelRequire("8mrqR");


var $6mKj3 = parcelRequire("6mKj3");


var $c6abH = parcelRequire("c6abH");

function $431bc41fbb9babca$export$2d18ca8a66126a1d() {
    const hasWindow = typeof window !== 'undefined';
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
        width: width,
        height: height
    };
}
const $431bc41fbb9babca$var$ALL_TIMES_ARRAY = Array(48).fill(0).map((_, i)=>`${Math.floor(i / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
const $431bc41fbb9babca$var$i18n = (0, $aXWIB.defineMessages)({
    acceptTitle: {
        id: "publish-modal.flag.accept",
        defaultMessage: "Accept"
    }
});
const $431bc41fbb9babca$export$b182675d91dd4643 = (scheduledDate)=>{
    const currTime = new Date();
    const baseTime = (0, $gsubZ.default)(currTime, 5);
    // Return empty array when it is already 5 minutes until tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (baseTime.toDateString() === tomorrow.toDateString()) return [];
    // Return array of valid time selections
    if (!!scheduledDate && (0, $da71s.default)(scheduledDate).toDateString() === baseTime.toDateString()) {
        // User selected same day, only return time in the future
        const baseHour = baseTime.getHours();
        const nextHour = baseHour + 1;
        // Time array
        const timesArray = Array(48 - nextHour * 2).fill(0).map((_, i)=>`${Math.floor((i + nextHour * 2) / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
        if (baseTime.getMinutes() < 30) // If current time is in first half of the hour, add {currentHour:30} to the time array
        timesArray.unshift(`${baseHour.toString().padStart(2, '0')}:30`);
        return timesArray;
    } else // User selected future day, return all times array
    return $431bc41fbb9babca$var$ALL_TIMES_ARRAY;
};
const $431bc41fbb9babca$export$6195456a656da885 = (date, time)=>{
    return date && time && (0, $cFEpk.default)(date) && (0, $cFEpk.default)(time) ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()) : undefined;
};
const $431bc41fbb9babca$export$9295f91b059cbee5 = ({ contentId: contentId, schedulePublishDate: schedulePublishDate, fragmentWriterInterop: fragmentWriterInterop })=>{
    try {
        fragmentWriterInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                schedulePublishInfo: {
                    __typename: 'SchedulePublishInfo',
                    date: schedulePublishDate,
                    minorEdit: false,
                    targetType: 'page',
                    versionComment: ''
                },
                __typename: 'Content'
            }
        });
    } catch  {}
};
const $431bc41fbb9babca$export$19a3e0c18ebaf6e6 = async ({ validationMessage: validationMessage, isTitleEmpty: isTitleEmpty, flags: flags, formatMessage: formatMessage, publish: publish, isAIEnabledForContent: isAIEnabledForContent, isLivePage: isLivePage })=>{
    let flagErrorId;
    // Will show a generic error flag if these three conditions not met
    // The validation query results do not differentiate b/w blank and whitespace title so we use isTitleEmpty to do so on the frontend side
    if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK && isAIEnabledForContent && !isLivePage && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE;
    else if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).DUPLICATE_TITLE) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE;
    const flagMessage = (0, $cHfGW.buildEditorFlagMessage)({
        errorData: {
            [flagErrorId]: true
        },
        formatMessage: formatMessage
    });
    if (flagErrorId === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE) {
        await flags.hideFlag('ai-generated-title-flag');
        await flags.showCustomFlag({
            id: 'ai-generated-title-flag',
            title: flagMessage?.title,
            description: flagMessage?.description,
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingBlockStart: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                label: "",
                size: "xsmall"
            })),
            actions: [
                {
                    content: formatMessage($431bc41fbb9babca$var$i18n.acceptTitle),
                    onClick: publish
                }
            ]
        });
    } else await flags.showErrorFlag({
        title: flagMessage?.title,
        description: flagMessage?.description
    });
};
const $431bc41fbb9babca$export$13107e6716590163 = (gqlRestrictionsInput)=>{
    if (!gqlRestrictionsInput) return undefined;
    return gqlRestrictionsInput;
};
const $431bc41fbb9babca$export$7521340df7373a8f = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    const processUserEdgesArray = (userEdgesArray)=>userEdgesArray.map((element)=>(0, $8mrqR.transformUserToREST)({
                ...element.node,
                hasSpaceEditPermission: true,
                hasSpaceViewPermission: true
            }));
    const processGroupEdgesArray = (groupEdgesArray)=>groupEdgesArray.map((element)=>(0, $8mrqR.transformGroupToREST)(element.node));
    const createRestrictionsObject = (operation, users, groups)=>({
            operation: operation,
            restrictions: {
                user: {
                    results: processUserEdgesArray(users)
                },
                group: {
                    results: processGroupEdgesArray(groups)
                }
            }
        });
    const readObj = createRestrictionsObject('read', usersWithReadRestriction, groupsWithReadRestriction);
    const updateObj = createRestrictionsObject('update', usersWithUpdateRestriction, groupsWithUpdateRestriction);
    return [
        readObj,
        updateObj
    ];
};
const $431bc41fbb9babca$export$756388d4cc11ef74 = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    return {
        read: {
            user: usersWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        },
        update: {
            user: usersWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        }
    };
};
module.exports["getTimesArray"] = $431bc41fbb9babca$export$b182675d91dd4643;
module.exports["mergeDateTime"] = $431bc41fbb9babca$export$6195456a656da885;
module.exports["cacheSchedulePublishTime"] = $431bc41fbb9babca$export$9295f91b059cbee5;
module.exports["displayPublishErrorFlag"] = $431bc41fbb9babca$export$19a3e0c18ebaf6e6;
module.exports["getRestrictionsForPublish"] = $431bc41fbb9babca$export$13107e6716590163;
module.exports["convertRestrictionsObjFromSchedulePublishInfo"] = $431bc41fbb9babca$export$7521340df7373a8f;
module.exports["convertGqlRestrictionsInputFromSchedulePublishInfo"] = $431bc41fbb9babca$export$756388d4cc11ef74;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("gsubZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb6ae770a72c6aa$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $lshox = parcelRequire("lshox");


var $b5utg = parcelRequire("b5utg");

var $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE = 60000;
function $bfb6ae770a72c6aa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $lshox.default)(dirtyDate, amount * $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("8mrqR", function(module, exports) {

var $7CLBv = parcelRequire("7CLBv");


var $c4ECQ = parcelRequire("c4ECQ");


var $9lU4Z = parcelRequire("9lU4Z");

class $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError extends Error {
    constructor(){
        super("Invalid restrictions object provided.  Restrictions objects must contain a 'read' ContentRestriction and an 'update' ContentRestriction.");
    }
}
class $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError extends Error {
    constructor(){
        super('Invalid restrictions were fetched from GraphQL.');
    }
}
const $5c6f8af6b02c47e8$var$restrictionIsEmpty = (contentRestriction)=>{
    return contentRestriction.restrictions.user.results.length === 0 && contentRestriction.restrictions.group.results.length === 0;
};
const $5c6f8af6b02c47e8$export$54aeac99fafa79ed = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction) && $5c6f8af6b02c47e8$var$restrictionIsEmpty(updateRestriction)) return (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS;
    else if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction)) return (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT;
    else return (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW;
};
const $5c6f8af6b02c47e8$export$b1e5e678c0890199 = (restObj, newRestrictionType, currentUser)=>{
    // This function applies a restrictionType to a RestrictionsRESTObj.
    // Some of the logic here is duplicated by `getPermissionsGroupsBasedOnRestrictionsType`
    // in RestrictionsDialog/restrictions-data-transform-helpers.tsx
    // Be sure that any changes you make to how this logic works are also made in that file.
    const oldRestrictionType = $5c6f8af6b02c47e8$export$54aeac99fafa79ed(restObj);
    const currentUserObj = {
        type: 'known',
        // The `as "known"` is needed to satisfy a Typescript error, since `type` gets assigned the type "string"
        accountId: currentUser.id,
        profilePicture: {
            path: currentUser.profilePicture.path
        },
        displayName: currentUser.displayName,
        publicName: currentUser.displayName,
        isExternalCollaborator: false
    };
    // First make a deep copy of the restObj.
    const restObjCopy = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(restObj);
    const readRestriction = restObjCopy.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObjCopy.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS) {
        // Empty out update and read arrays.
        readRestriction.restrictions.user.results = [];
        readRestriction.restrictions.group.results = [];
        updateRestriction.restrictions.user.results = [];
        updateRestriction.restrictions.group.results = [];
        return restObjCopy;
    } else if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) {
            readRestriction.restrictions.user.results = [];
            readRestriction.restrictions.group.results = [];
            return restObjCopy;
        } else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) return restObjCopy;
        else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    } else {
        // newRestrictionType === ContentRestrictionType.RESTRICT_VIEW
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) return restObjCopy;
        else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
            readRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        } else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            readRestriction.restrictions.user.results.push(currentUserObj);
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    }
// Permissions levels:
// NO_RESTRICTIONS
// RESTRICT_EDIT
// RESTRICT_VIEW
//
// To move upwards on that list, just empty out the restrictions arrays.
// To move downwards on that list, you have to add the current user into the correct restrictions segment.
};
const $5c6f8af6b02c47e8$var$convertRESTUser = (restUser)=>{
    return {
        key: `USER-${restUser.accountId}`,
        entityType: (0, $c4ECQ.EntityType).USER,
        permissions: [],
        displayName: restUser.displayName,
        accountId: restUser.accountId,
        profilePicture: {
            path: restUser.profilePicture.path
        },
        hasSpaceViewPermission: restUser?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: restUser?.hasSpaceEditPermission ?? true,
        permissionType: restUser.isExternalCollaborator ? (0, $9lU4Z.SitePermissionType).EXTERNAL : (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$var$convertRESTGroup = (restGroup)=>{
    return {
        key: `GROUP-${restGroup.id}`,
        entityType: (0, $c4ECQ.EntityType).GROUP,
        permissions: [],
        name: restGroup.name,
        permissionType: (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$export$a9b84852f592ee6c = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    // TODO It may be possible to re-use some of the logic in
    // restrictions-data-transform-helpers.tsx here.
    // First, make a map from accountIds or group ids to their corresponding objects.
    const userGroupMap = new Map();
    for (const user of readRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const group of readRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const user of updateRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    for (const group of updateRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    // Return an array out of all the values from the map.
    // This matches the format of the usersAndGroups object.
    return Array.from(userGroupMap).map(([, value])=>value);
};
const $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061 = (user)=>{
    return {
        type: 'known',
        accountId: user?.accountId ?? '',
        publicName: user?.publicName ?? '',
        profilePicture: {
            path: user?.profilePicture?.path ?? ''
        },
        email: user?.email ?? '',
        displayName: user?.displayName ?? '',
        hasSpaceViewPermission: user?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: user?.hasSpaceEditPermission ?? true,
        isExternalCollaborator: user.permissionType === (0, $9lU4Z.SitePermissionType).EXTERNAL
    };
};
const $5c6f8af6b02c47e8$export$354ad6f5846ff4ac = (group)=>{
    return {
        type: 'group',
        name: group?.name ?? '',
        id: group?.id ?? '',
        usageType: group?.usageType ?? null
    };
};
const $5c6f8af6b02c47e8$var$isDefined = (value)=>{
    return value != null;
};
const $5c6f8af6b02c47e8$export$a57b08835223f9b8 = (queryData)=>{
    const readRestriction = queryData?.content?.nodes?.[0]?.restrictions?.read?.restrictions;
    const updateRestriction = queryData?.content?.nodes?.[0]?.restrictions?.update?.restrictions;
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError();
    const readObj = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const updateObj = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    readObj.restrictions.user.results = (readRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    readObj.restrictions.group.results = (readRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    updateObj.restrictions.user.results = (updateRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    updateObj.restrictions.group.results = (updateRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    return [
        readObj,
        updateObj
    ];
};
const $5c6f8af6b02c47e8$export$9281fb4d0a89ade8 = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    const onlyOneUserCanRead = readRestriction.restrictions.user.results.length === 1;
    const noGroupsCanRead = readRestriction.restrictions.group.results.length === 0;
    const onlyOneUserCanUpdate = updateRestriction.restrictions.user.results.length === 1;
    const noGroupsCanUpdate = updateRestriction.restrictions.group.results.length === 0;
    return onlyOneUserCanRead && noGroupsCanRead && onlyOneUserCanUpdate && noGroupsCanUpdate;
};
module.exports["getRestrictionsTypeFromRESTObj"] = $5c6f8af6b02c47e8$export$54aeac99fafa79ed;
module.exports["getUsersAndGroupsFromRESTObj"] = $5c6f8af6b02c47e8$export$a9b84852f592ee6c;
module.exports["transformUserToREST"] = $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061;
module.exports["transformGroupToREST"] = $5c6f8af6b02c47e8$export$354ad6f5846ff4ac;
module.exports["transformGraphQLQueryToRESTObj"] = $5c6f8af6b02c47e8$export$a57b08835223f9b8;
module.exports["restrictionsArePrivateToYouOnly"] = $5c6f8af6b02c47e8$export$9281fb4d0a89ade8;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("9lU4Z", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $4fac0aee9a82e652$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $4fac0aee9a82e652$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $4fac0aee9a82e652$export$8995abb8169b2cb8;

});

parcelRegister("c6abH", function(module, exports) {
const $39da9b0f89d8b5d0$export$e089b3c2861d2024 = '9:00';
const $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $39da9b0f89d8b5d0$export$ec93f019c59056da = 5;
const $39da9b0f89d8b5d0$export$45c85543ba71221d = 'yyyy-MM-dd';
var $39da9b0f89d8b5d0$export$377e0d8530a6da1a = /*#__PURE__*/ function(PublishErrorFlagKeys) {
    PublishErrorFlagKeys["TITLE_IS_BLANK"] = "TITLE_IS_BLANK";
    PublishErrorFlagKeys["DUPLICATE_TITLE"] = "TITLE_EXISTS_IN_SPACE";
    return PublishErrorFlagKeys;
}({});
const $39da9b0f89d8b5d0$export$9467f27273d92816 = {
    PMF1: 'PMF1',
    PMF2: 'PMF2',
    USB1: 'USB1',
    PBWMO1: 'PBWMO1',
    PBWMO2: 'PBWMO2',
    PBWMO3: 'PBWMO3',
    PBWMO4: 'PBWMO4',
    PBWMO5: 'PBWMO5',
    PMKS1: 'PMKS1',
    PMKS2: 'PMKS2'
};
module.exports["DEFAULT_TIME"] = $39da9b0f89d8b5d0$export$e089b3c2861d2024;
module.exports["TIME_FORMAT"] = $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8;
module.exports["MINUTES_IN_FUTURE"] = $39da9b0f89d8b5d0$export$ec93f019c59056da;
module.exports["DATE_FORMAT"] = $39da9b0f89d8b5d0$export$45c85543ba71221d;
module.exports["PublishErrorFlagKeys"] = $39da9b0f89d8b5d0$export$377e0d8530a6da1a;
module.exports["SHORTCUT_KEYS"] = $39da9b0f89d8b5d0$export$9467f27273d92816;

});

parcelRegister("1N2OF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ggpj = parcelRequire("1ggpj");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $3jwuS = parcelRequire("3jwuS");


var $7mpOv = parcelRequire("7mpOv");


var $c0rhi = parcelRequire("c0rhi");


var $f5bZm = parcelRequire("f5bZm");


var $h7eE1 = parcelRequire("h7eE1");


var $jVFPV = parcelRequire("jVFPV");

const $f6c5568d6d5a516f$export$3d87df4b3544fccb = ({ contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onBeforeValidation: onBeforeValidation, onValidationSuccess: onValidationSuccess, analyticsSource: analyticsSource, optimisticTitle: optimisticTitle })=>{
    const intl = (0, $aXWIB.useIntl)();
    // Changes to EditorTitle are debounced if the page is a draft, which we need to account for
    const titleDebounceTime = isUnpublishedDraft ? (0, $1ggpj.onChangeTitleDebounceTime) : 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f5bZm.usePublishModalAnalyticsEvent)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Since the validatePageAndOpenModal function may be running after this component has unmounted,
    // we have to query the apolloClient directly rather than using useQuery's refetch function.
    const validatePageAndOpenModal = (0, $42omo.useCallback)((actionSubjectId)=>{
        const validatePage = async ()=>{
            // Live Pages only save changes to the `realTitle` when it is valid,
            // so we need to use the `optimisticTitle` here to get what the user
            // has actually typed into the title field, and then show the correct flag.
            const { title: realTitle } = await retrieveEditorTitleAndContent();
            // ?? must be used here to explicitly check null and undefined because we want to use optmisticTitle if it is an empty string, which is also falsey.
            const title = optimisticTitle ?? realTitle;
            try {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: (0, $h7eE1.ValidatePagePublishQuery),
                    errorPolicy: 'all',
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId ?? '',
                        type: contentType,
                        title: title
                    }
                });
                // This is the same logic used to calculate `isTitleEmpty` in EditorPrimaryToolbarComponents.
                const isTitleEmpty = !title;
                if (!data.validatePagePublish?.isValid) await (0, $jVFPV.displayPublishErrorFlag)({
                    validationMessage: data.validatePagePublish?.message ?? '',
                    isTitleEmpty: isTitleEmpty,
                    flags: flags,
                    formatMessage: intl.formatMessage,
                    publish: validatePageAndOpenModal('PublishButtonInFlag'),
                    isAIEnabledForContent: isAIEnabledForContent,
                    isLivePage: isLivePage
                });
                else onValidationSuccess();
            } catch (error) {
                if (error) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    if (!(0, $6fil2.containsNetworkError)(error) && !(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                        attribution: (0, $3IBnw.Attribution).PAGE_MODES
                    });
                }
            }
        };
        return async ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: actionSubjectId,
                    source: analyticsSource,
                    attributes: {
                        isUnpublishedDraft: isUnpublishedDraft
                    }
                }
            }).fire();
            setTimeout(async ()=>{
                onBeforeValidation();
                await validatePage();
            }, titleDebounceTime);
        };
    }, [
        contentId,
        contentType,
        retrieveEditorTitleAndContent,
        createAnalyticsEvent,
        flags,
        intl.formatMessage,
        titleDebounceTime,
        isUnpublishedDraft,
        analyticsSource,
        onBeforeValidation,
        onValidationSuccess,
        optimisticTitle,
        isAIEnabledForContent,
        isLivePage
    ]);
    return validatePageAndOpenModal;
};
module.exports["usePrePublishTitleValidation"] = $f6c5568d6d5a516f$export$3d87df4b3544fccb;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("f5bZm", function(module, exports) {

var $hw7IX = parcelRequire("hw7IX");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    /**
   * cache-only since it is utilizing the same query that the PublishButtonWithMoreOptions component
   * is using, so the data should already be available within the cache which is why there is no
   * error or loading checks as well.
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hw7IX.default), {
        errorPolicy: 'all',
        fetchPolicy: 'cache-only',
        variables: {
            contentId: contentId
        }
    });
    // Setup the rest of the necessary info for our analytics events that came from the query
    const analyticEventData = (0, $42omo.useMemo)(()=>{
        return {
            objectId: contentId,
            objectType: data?.singleContent?.type ?? undefined,
            containerId: data?.singleContent?.space?.id ?? undefined
        };
    }, [
        data,
        contentId
    ]);
    const createAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        payload.data.objectType = analyticEventData.objectType;
        payload.data.objectId = analyticEventData.objectId;
        payload.data.containerType = 'space';
        payload.data.containerId = analyticEventData.containerId;
        return akCreateAnalyticsEvent(payload);
    }, [
        analyticEventData,
        akCreateAnalyticsEvent
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};
module.exports["usePublishModalAnalyticsEvent"] = $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba;

});

parcelRegister("hw7IX", function(module, exports) {
/**
 * @generated SignedSource<<354d2cc8509216510080198deb48adda>>
 * @relayHash 5f6af3c9067662d2f2453cffe85e870d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db
const $40611a622a6050f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "concreteType": "ConfluencePersonConnection",
            "kind": "LinkedField",
            "name": "personConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePersonEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ConfluencePerson",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "SchedulePublishInfo",
                    "kind": "LinkedField",
                    "name": "schedulePublishInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "date"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "versionComment"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "minorEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        },
                        {
                            "concreteType": "TargetLocation",
                            "kind": "LinkedField",
                            "name": "targetLocation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "parentId"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "destinationSpace",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ScheduledRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                },
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5f6af3c9067662d2f2453cffe85e870d",
            "id": "5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db",
            "metadata": {},
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "operationKind": "query",
            "text": "query usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id,type,space{id},schedulePublishInfo{date,versionComment,minorEdit,targetType,targetLocation{parentId,destinationSpace{id,key,alias}},restrictions{update{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}},read{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}}}}}}"
        }
    };
}();
$40611a622a6050f5$var$node.hash = "a8a0b6dda1e0a34e0ddf825a8ab4995a";
var $40611a622a6050f5$export$2e2bcd8739ae039 = $40611a622a6050f5$var$node;
module.exports["default"] = $40611a622a6050f5$export$2e2bcd8739ae039;

});

parcelRegister("h7eE1", function(module, exports) {

var $lWcGs = parcelRequire("lWcGs");

const $a57349b93ecbf15f$export$6d6976f1200f02ec = (0, $lWcGs.default);
module.exports["ValidatePagePublishQuery"] = $a57349b93ecbf15f$export$6d6976f1200f02ec;

});

parcelRegister("lWcGs", function(module, exports) {
/**
 * @generated SignedSource<<f6217ef0f6963cd143de1161040e64f4>>
 * @relayHash 24fbb3cff8b05eaa1a5b7d5ae6a6a9c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646
const $462ba838f57fbdac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "draft"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "type"
                }
            ],
            "concreteType": "PageValidationResult",
            "kind": "LinkedField",
            "name": "validatePagePublish",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isValid"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24fbb3cff8b05eaa1a5b7d5ae6a6a9c0",
            "id": "be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646",
            "metadata": {},
            "name": "ValidatePagePublishQuery",
            "operationKind": "query",
            "text": "query ValidatePagePublishQuery($contentId:ID!,$type:String,$title:String){validatePagePublish(id:$contentId,status:\"draft\",type:$type,title:$title){isValid,message}}"
        }
    };
}();
$462ba838f57fbdac$var$node.hash = "8954a1a5f4b5c46209e8bdbdcef7f2f7";
var $462ba838f57fbdac$export$2e2bcd8739ae039 = $462ba838f57fbdac$var$node;
module.exports["default"] = $462ba838f57fbdac$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<85c10c3297d9370c832c39704b0be624>>
 * @relayHash f5d07637afe71c7ca06b7f159493ea94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "otherContentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "transitionType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            v4 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v8 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v9 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v10 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "success"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v14 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v15 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v17 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v23 = [
        v5 /*: any*/ ,
        v20 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v24 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v25 = [
        v21 /*: any*/ 
    ], v26 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v23 /*: any*/ 
            }
        ]
    }, v27 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v25 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v20 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v5 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5d07637afe71c7ca06b7f159493ea94",
            "id": "e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType){content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a2315c6dd75143b0285f57068b70bc22";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("sLZsl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9e73f43295b80088$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isAutoConverted: false
    },
    actions: {
        setIsAutoConverted: (isAutoConverted)=>({ setState: setState })=>{
                setState({
                    isAutoConverted: isAutoConverted
                });
            }
    },
    name: 'isAutoConverted'
});
const $9e73f43295b80088$var$getAutoConvertState = (state)=>{
    return state.isAutoConverted;
};
const $9e73f43295b80088$export$dc84155a8aa7f285 = (0, $9zUhf.createHook)($9e73f43295b80088$var$Store, {
    selector: $9e73f43295b80088$var$getAutoConvertState
});
module.exports["useAutoConvertState"] = $9e73f43295b80088$export$dc84155a8aa7f285;

});

parcelRegister("cQhbe", function(module, exports) {
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};
module.exports["AutoConvertEvent"] = $3ddd96eb421fb45c$export$c184dc244f9dacf4;
module.exports["AutoConvertActionSubject"] = $3ddd96eb421fb45c$export$a248ed70ead7ff08;
module.exports["RevertAutoConvertEvent"] = $3ddd96eb421fb45c$export$d8b435b7aa875953;
module.exports["AutoConvertPanelEvent"] = $3ddd96eb421fb45c$export$b22548c36d783030;
module.exports["AutoConversionByLineEvent"] = $3ddd96eb421fb45c$export$e8dbd545dc7c3af0;
module.exports["sendEditorConversionAnalyticsPageEvent"] = $3ddd96eb421fb45c$export$b4535793cfa6d80a;
module.exports["sendEditorConversionAnalyticsPanelEvent"] = $3ddd96eb421fb45c$export$e045315387fc4262;

});

parcelRegister("6ysok", function(module, exports) {
/**
 * @generated SignedSource<<4d49c32a869f466fc6b565b519570705>>
 * @relayHash 82f12ac8b34ad91537ec9fdf459226f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896
const $3ac88c8ffed86645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiryDateTime"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "82f12ac8b34ad91537ec9fdf459226f1",
            "id": "f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896",
            "metadata": {},
            "name": "ContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value,duration,expiryDateTime},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$3ac88c8ffed86645$var$node.hash = "f17b5112a287e607ae81ac1df8d1533e";
var $3ac88c8ffed86645$export$2e2bcd8739ae039 = $3ac88c8ffed86645$var$node;
module.exports["default"] = $3ac88c8ffed86645$export$2e2bcd8739ae039;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.d5287d5e.js.map
